import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnsubscribeService } from './unsubscribe.service';
import { EmailToDto, MemberClientResponse, MemberIdentiiesResponse, SendEmailDto, TemplateResolutionRequestDto, 
    TemplateResolutionResponseDto, UnsubscribeActivityDto, UnsubscribeActivitySearchDto, UnsubscribeGroupConfigDto, 
    UnsubscribeGroupDto, UnsubscribePreferencesDto } from './unsubscribe-dtos';
import { Subscription } from 'rxjs';
import { Constant } from './../core/constant';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: 'unsubscribe.component.html',
    styleUrls: ['unsubscribe.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UnsubscribeComponent implements OnInit {

    public errorString: string = '';
    public emailAddress: string = 'fred@work.com';
    private notificationKey: string = 'APIKEY_LB';
    private templateId: string = null;
    public saveCalled: boolean = false;
    public loading: boolean = false;
    public useGlobalUnsubscribeOnly: boolean = true;
    public unsubscribeOptions: any[];
    public unsubscribeGroups: UnsubscribeGroupDto[];
    private globalUnsubscribeGroup: UnsubscribeGroupDto = null;
    public activityResults: UnsubscribeActivityDto[];
    public unsubscribeAll: boolean = false;
    public configDto: UnsubscribeGroupConfigDto = null;
    public inputParams: string[];
    public templateDefinitionId: string;
    public resolvedTemplate: string;
    public templateDefintionSubject: string;
    public configKey: string;
    public recipientId: string;
    public receiptClient: string;
    public isSaveBtnClicked: boolean = true;

    private getUnsubscribeGroupConfigsSubscription: Subscription = null;
    private getUnsubscribeGroupsSubscription: Subscription = null;
    private getUnsubscribeGroupActivitySubscription: Subscription = null;
    private savePreferencesSubscription: Subscription = null;
    private getResolvedTemplateSubscription: Subscription = null;
    private getTemplateDefinitionSubscription: Subscription = null;
    private getEmailSentSuccessStatusSubscription: Subscription = null;
    private sendEmailSubscription: Subscription = null;
    private getConfigValueSubscription: Subscription = null;
    private getMemberIdByEmailSubscription: Subscription = null;
    private getClientCodeByMemberIdSubscription: Subscription = null;

    constructor(private _activatedRoute: ActivatedRoute, private _unsubscribeService: UnsubscribeService) {

        this.emailAddress = this._activatedRoute.snapshot.params['emailaddress'];
        console.log('UnsubscribeComponent: emailaddress: ', this.emailAddress);

        this.notificationKey = this._activatedRoute.snapshot.params['notificationkey'];
        console.log('UnsubscribeComponent: notificationkey: ', this.notificationKey);

        this.templateId = this._activatedRoute.snapshot.params['templateid'];
        console.log('UnsubscribeComponent: templateid: ', this.templateId);

        if (this.emailAddress === null || this.emailAddress === undefined) {

            this.errorString += 'Email address is required. ';
            console.error('Email address is required. ');
        }

        if (this.notificationKey === null || this.notificationKey === undefined) {

            this.errorString += 'Notification key is required. ';
            console.error('Notification key is required. ');
        }

        if (this.templateId === null || this.templateId === undefined) {

            this.errorString += 'Client id is required.';
            console.error('Client id is required.');
        }
    }

    ngOnInit(): void {
        this.loading = true;
        this.setUnsubscribeButtons();
        this.getUnsubscribeGroupConfigs();
        this.setUnsubscribeGroups();

    }

    public save() {

        this.savePreferencesSubscription?.unsubscribe();

        if( !this.isSaveBtnClicked) {

            if (this.emailAddress !== null && this.emailAddress !== undefined && this.emailAddress.trim() !== '') {

                if (this.unsubscribeAll && this.configKey.toLowerCase() == Constant.EmailUnSubscribeSuccessTemplateId.toLowerCase()) {
                    
                    this.isSaveBtnClicked = true;
                    this.sendEmail();

                } else if (!this.unsubscribeAll && this.configKey.toLowerCase() == Constant.EmailSubscribeSuccessTemplateId.toLowerCase()) {

                    this.isSaveBtnClicked = true;
                    this.savePreferences();
                }

            } else {            
                this.errorString = 'Email address is required for the save method.';
                console.error(this.errorString);
            }
        }
    }

    private getEmailUnsubscribeActivity(emailAddress: string) {

        this.getUnsubscribeGroupActivitySubscription?.unsubscribe();

        let searchDto: UnsubscribeActivitySearchDto = new UnsubscribeActivitySearchDto();
        searchDto.filters = [{ property: 'emailAddress', value: emailAddress, operator: 'equals' }];
        searchDto.pageNumber = 1;
        searchDto.pageSize = 10000;

        this.getUnsubscribeGroupActivitySubscription = this._unsubscribeService.getUnsubscribeActivityForEmailAddress(searchDto).subscribe({
            next: (activity) => {
                activity.data = activity.data.filter(item => (item.resubscribeDate === null || item.resubscribeDate === undefined ));

                this.activityResults = activity.data;

                activity.data.forEach(element => {
                    
                    let group: UnsubscribeGroupDto = this.unsubscribeGroups.find(x => x.id === element.emailUnsubscribeGroupId);

                    if (group !== null && group !== undefined) {
                        group.selected = 'true';
                    }
                });

                let selectedList: UnsubscribeGroupDto[] = this.unsubscribeGroups.filter(x => x.selected === 'true');

                if (selectedList !== undefined && selectedList !== null && selectedList.length === this.unsubscribeGroups.length) {

                    if (!this.useGlobalUnsubscribeOnly) {
                        this.unsubscribeAll = true;
                        this.configKey = Constant.EmailSubscribeSuccessTemplateId;
                    } else {
                        if (selectedList.length === 1) {
                            // using only the global unsubscribe group and only have one activity for the user from the server,
                            // so we can infer that the user is unsubscribed from all groups
                            this.unsubscribeAll = true;
                            this.configKey = Constant.EmailSubscribeSuccessTemplateId;
                        } else {
                            this.unsubscribeAll = false;
                            this.configKey = Constant.EmailUnSubscribeSuccessTemplateId;
                        }
                    }
                } else {
                    this.unsubscribeAll = false;
                    this.configKey = Constant.EmailUnSubscribeSuccessTemplateId;
                }

                this.getConfigValue(this.configKey);

                this.loading = false;
            },
            error: (err) => {
                this.loading = false;
                this.errorString = 'An error occurred getting the email unsubscribe groups.';
                console.error(err, this.errorString, 'Get Email Unsubscribe Groups');
            }
        });
    }

    private setUnsubscribeGroups() {
        this.unsubscribeGroups = [];

        this.getUnsubscribeGroupsSubscription?.unsubscribe();

        if (this.templateId === null || this.templateId === undefined) {

            this.errorString = 'Template Id is required to get the unsubscribe groups.';
            console.error(this.errorString);

        } else {

            this.getUnsubscribeGroupsSubscription = this._unsubscribeService.getUnsubscribeGroupsForTemplate(this.templateId).subscribe({
                next: (unsubscribeGroups) => {

                    unsubscribeGroups.sort(function (a, b) {
                        if (a.unsubscribeGroupName.toLowerCase() < b.unsubscribeGroupName.toLowerCase()) {
                            return -1;
                        }
                        if (a.unsubscribeGroupName.toLowerCase() > b.unsubscribeGroupName.toLowerCase()) {
                            return 1;
                        }
                    });

                    this.globalUnsubscribeGroup = unsubscribeGroups.find(x => x.representsAllUnsubscribeGroups === true);

                    if (!this.useGlobalUnsubscribeOnly) {

                        // remove the global unsubscribe group from the overall list of email unsubscribe groups
                        if (this.globalUnsubscribeGroup !== null && this.globalUnsubscribeGroup !== undefined) {

                            const index: number = unsubscribeGroups.indexOf(this.globalUnsubscribeGroup);

                            if (index !== -1) {
                                unsubscribeGroups.splice(index, 1);
                            }
                        }

                        this.unsubscribeGroups = unsubscribeGroups;

                        this.unsubscribeGroups.forEach(element => {
                            element.selected = 'false';
                        });

                    } else {

                        // only use the global unsubscribe group
                        this.unsubscribeGroups.push(this.globalUnsubscribeGroup);
                    }

                    this.getEmailUnsubscribeActivity(this.emailAddress);
                },
                error: (err) => {
                    this.loading = false;
                    this.errorString = 'An error occurred getting the email unsubscribe groups.';
                    console.error(err, this.errorString, 'Get Email Unsubscribe Groups');
                }
            });
        }
    }

    private getUnsubscribeGroupConfigs() {

        this.getUnsubscribeGroupConfigsSubscription?.unsubscribe();

        this.getUnsubscribeGroupConfigsSubscription = this._unsubscribeService.getUnsubscribeGroupConfigs().subscribe({
            next: (config) => {

                this.configDto = config;
            },
            error: (err) => {
                this.loading = false;
                this.errorString = 'An error occurred getting the email unsubscribe groups.';
                console.error(err, this.errorString, 'Get Email Unsubscribe Groups');
            }
        });
    }

    public updateGlobalSelection($event) {
        
        if ($event.value === 'false') {
            this.unsubscribeAll = false;
        } else {
            
            let allSelected: boolean = true;
            this.unsubscribeGroups.forEach(group => {

                if (allSelected && group.selected === 'false') {
                    allSelected = false;
                }
            });

            this.unsubscribeAll = allSelected;
        }
    }

    public updateSelections($event) {       
        if ($event.checked) {
            this.unsubscribeGroups.forEach(group => {
                group.selected = 'true';
            });

            if(this.isSaveBtnClicked) {
               if(this.configKey.toLowerCase() == Constant.EmailUnSubscribeSuccessTemplateId.toLowerCase()) {
                 this.isSaveBtnClicked = false;
               }
            } else {
                if(this.configKey.toLowerCase() == Constant.EmailSubscribeSuccessTemplateId.toLowerCase()) {
                    this.isSaveBtnClicked = true;
                }
            }
             
        } else {
            this.unsubscribeGroups.forEach(group => {
                group.selected = 'false';
            });

            if(this.isSaveBtnClicked) {
                if(this.configKey.toLowerCase() == Constant.EmailSubscribeSuccessTemplateId.toLowerCase()) {
                    this.isSaveBtnClicked = false;
                }
            }  else {           
                if(this.configKey.toLowerCase() == Constant.EmailUnSubscribeSuccessTemplateId.toLowerCase()) {
                    this.isSaveBtnClicked = true;
                }
            }
        }
    }

    private setUnsubscribeButtons() {
        this.unsubscribeOptions = [{label: 'No', value: 'false'}, {label: 'Yes', value: 'true'}];
    }

    private getTemplateDefinitionById() {
       
        this.getTemplateDefinitionSubscription?.unsubscribe();
 
        this.templateDefintionSubject = '';
 
        this.getTemplateDefinitionSubscription = this._unsubscribeService.getTemplate
        (this.templateDefinitionId).subscribe( {
             next: (result: any) => {
                 if(result && !this.isEmptyOrNullOrUndefined(result.subject)) {
                     this.templateDefintionSubject = result.subject;
                 }
             },
             error: (err: any) => { 
                 this.errorString = 'An error occurred getting the template definition record by id.';
                 console.error(err, this.errorString, 'Get Template Definition'); 
             }
         }
        );
     }

     private getEmailSentSuccessStatus(requestId: string) {
       
        this.getEmailSentSuccessStatusSubscription?.unsubscribe();
 
        this.getEmailSentSuccessStatusSubscription = this._unsubscribeService.getEmailSentSuccessStatus
        (requestId).subscribe( {
             next: (result: boolean) => {
                 
                if(result) {
                     
                    this.savePreferences();

                } else {

                    this.saveCalled = false;
                    this.errorString = 'Email sent status returned false. Not updating the preference.';
                    console.error(this.errorString, 'Email Delivery Success'); 
                }
             },
             error: (err: any) => { 
                 this.saveCalled = false;
                 this.errorString = 'An error occurred determining the success of the email send request.';
                 console.error(err, this.errorString, 'Email Delivery Success'); 
             }
         }
        );
     }

    private getResolvedTemplate() {
       
       this.getResolvedTemplateSubscription?.unsubscribe();

       const templateReqObject: TemplateResolutionRequestDto = this.getResolveTempReqObj();

       this.resolvedTemplate = '';

       this.getResolvedTemplateSubscription = this._unsubscribeService.getResolvedTemplate
       (templateReqObject).subscribe( {
            next: (result: TemplateResolutionResponseDto) => {
                if(!this.isEmptyOrNullOrUndefined(result.resolvedTemplate)) {
                    let newTemplate: string = result?.resolvedTemplate.replace('<emailaddress>', this.emailAddress);
                    this.resolvedTemplate = newTemplate;
                }
            },
            error: (err: any) => { 
                this.errorString = 'An error occurred getting the resolved template.';
                console.error(err, this.errorString, 'Get Resolved Template'); 
            }
        }
    );
    }

    private getResolveTempReqObj(): TemplateResolutionRequestDto {

        let templateRequest: TemplateResolutionRequestDto  = new TemplateResolutionRequestDto();

        templateRequest.templateDefinitionId = this.templateDefinitionId;
        templateRequest.asFullHtmlDocument = false;
        templateRequest.inputParams = [{
            queryParamName:"memberId",
            queryParamValue: this.recipientId
        }];

        return templateRequest;
    }

    private getEmailReqObj(): SendEmailDto {

        let emailToDto: EmailToDto = new EmailToDto();
       
        if (!this.isEmptyOrNullOrUndefined(this.emailAddress)) {
            emailToDto.email = this.emailAddress;
            emailToDto.name = this.emailAddress;
        }

        let emailDto: SendEmailDto = new SendEmailDto();


        if (!this.isEmptyOrNullOrUndefined(this.notificationKey)) {
            emailDto.notificationKey = this.notificationKey;
        }
       if (!this.isEmptyOrNullOrUndefined(this.templateId)) {
            emailDto.templateDefinitionId = this.templateDefinitionId;
        }

        emailDto.subject = this.templateDefintionSubject;
        emailDto.body = this.resolvedTemplate;
        emailDto.tos.push(emailToDto);
        emailDto.isHtml = true;
        emailDto.sendImmediately = true;
        emailDto.bypassUnsubscribeListManagement = false;

        if (!this.isEmptyOrNullOrUndefined(this.recipientId)) {
            emailDto.recipientId = this.recipientId;
        }

        if (!this.isEmptyOrNullOrUndefined(this.receiptClient)) {
            emailDto.recipientClient = this.receiptClient;
        }


        return emailDto;
    }

    private sendEmail() {

        const emailReqObject: SendEmailDto = this.getEmailReqObj();

        this.sendEmailSubscription?.unsubscribe();
        this.saveCalled = true;
       
        this.sendEmailSubscription = this._unsubscribeService.sendEmail(emailReqObject).subscribe({
            next: (response: string) => {

            if(!this.isEmptyOrNullOrUndefined(response) && (this.configKey.toLowerCase() == Constant.EmailUnSubscribeSuccessTemplateId.toLowerCase())) {
                this.getEmailSentSuccessStatus(response);

            }  else {
              this.saveCalled = false;
              this.setUnsubscribeGroups();
            }
            },
            error: (err) => {
                this.loading = false;
                this.saveCalled = false;
                this.errorString = 'An error occurred sending the email.';
                console.error(err, this.errorString, 'Send Email');
            }
        });
    }

    private savePreferences() {
        let preferencesDto = new UnsubscribePreferencesDto();
        preferencesDto.emailAddress = this.emailAddress;
        preferencesDto.resubscribeGroupIds = [];
        preferencesDto.unsubscribeGroupIds = [];

        if (!this.unsubscribeAll) {

            this.unsubscribeGroups.forEach(group => {

                if (group.selected === 'true') {
                    preferencesDto.unsubscribeGroupIds.push(group.id);
                } else if (group.selected === 'false') {
                    preferencesDto.resubscribeGroupIds.push(group.id);
                }
            });

        } else {

            if (this.useGlobalUnsubscribeOnly) {

                if (this.globalUnsubscribeGroup !== null && this.globalUnsubscribeGroup !== undefined
                    && !preferencesDto.unsubscribeGroupIds.includes(this.globalUnsubscribeGroup.id)) {

                    preferencesDto.unsubscribeGroupIds.push(this.globalUnsubscribeGroup.id);
                }

            } else {

                // unsubscribe from all groups and add the global unsubscribe group
                this.unsubscribeGroups.forEach(group => {

                    preferencesDto.unsubscribeGroupIds.push(group.id);

                    if (this.globalUnsubscribeGroup !== null && this.globalUnsubscribeGroup !== undefined
                        && !preferencesDto.unsubscribeGroupIds.includes(this.globalUnsubscribeGroup.id)) {

                        preferencesDto.unsubscribeGroupIds.push(this.globalUnsubscribeGroup.id);
                    }
                });
            }
        }

        this.saveCalled = true;

        this.savePreferencesSubscription = this._unsubscribeService.persistPreferences(preferencesDto, this.notificationKey).subscribe({
            next: (activity) => {

                console.log('preferences saved', activity);

                if(this.configKey.toLowerCase() == Constant.EmailSubscribeSuccessTemplateId.toLowerCase()) {
                    this.sendEmail();
                } else {
                    // refresh the page
                    this.saveCalled = false;
                    this.setUnsubscribeGroups();
                }
                
            },
            error: (err) => {
                this.saveCalled = false;
                this.errorString = 'An error occurred saving the email unsubscribe group preferences.';
                console.error(err, this.errorString, 'Save Email Unsubscribe Group Preferences');
            }
        });
    }

    private isEmptyOrNullOrUndefined(str: string | null | undefined): boolean {
        return !str || str.trim() === '';
    }

    private getConfigValue(key: string) {

        this.getConfigValueSubscription?.unsubscribe();

        this.getConfigValueSubscription = this._unsubscribeService.getConfig(key).subscribe( {
            next: (result: any) => {
                if(!this.isEmptyOrNullOrUndefined(result)) {

                    this.templateDefinitionId = result;
                    this.getMemberIdByEmail();
                    this.getTemplateDefinitionById();
                    
                    
                }
            },
            error: (err: any) => { 
                this.loading = false;
                this.errorString = 'An error occurred getting the config value.';
                console.error(err, this.errorString, 'Get Config Value'); 
            }
        });

    }

    private getMemberIdByEmail() {

        this.getMemberIdByEmailSubscription?.unsubscribe();

        this.getMemberIdByEmailSubscription = this._unsubscribeService.getMemberIdByEmail(this.emailAddress).subscribe( {
            next: (result: MemberIdentiiesResponse) => {
                if(result) {

                    this.recipientId = result.memberId;
                    if(this.recipientId) {
                      this.getResolvedTemplate();
                      this.getClientCodeByMemberId(this.recipientId);
                    }
                }
            },
            error: (err: any) => { 
                this.loading = false;
                this.errorString = 'An error occurred getting the member id value.';
                console.error(err, this.errorString, 'Get Member Id by email'); 
            }
        });

    }

    private getClientCodeByMemberId(memberId: string) {

        this.getClientCodeByMemberIdSubscription?.unsubscribe();

        this.getClientCodeByMemberIdSubscription = this._unsubscribeService.getClientCodeByMemberId(memberId).subscribe( {
            next: (result: MemberClientResponse) => {
                if(result) {

                 this.receiptClient = result.clientCode;
                    
                }
            },
            error: (err: any) => { 
                this.loading = false;
                this.errorString = 'An error occurred getting the client value.';
                console.error(err, this.errorString, 'Get Client Code By MemberId'); 
            }
        });

    }

    ngOnDestroy() {

        this.getUnsubscribeGroupsSubscription?.unsubscribe();
        this.getUnsubscribeGroupActivitySubscription?.unsubscribe();
        this.savePreferencesSubscription?.unsubscribe();
        this.getUnsubscribeGroupConfigsSubscription?.unsubscribe();
        this.getResolvedTemplateSubscription?.unsubscribe();
        this.sendEmailSubscription?.unsubscribe();
        this.getConfigValueSubscription?.unsubscribe();
        this.getTemplateDefinitionSubscription?.unsubscribe();
        this.getEmailSentSuccessStatusSubscription?.unsubscribe();
        this.getMemberIdByEmailSubscription?.unsubscribe();
        this.getClientCodeByMemberIdSubscription?.unsubscribe();

    }
}
